import script from "./StaticBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaticBanner.vue?vue&type=script&setup=true&lang=ts"

import "./StaticBanner.vue?vue&type=style&index=0&id=1837f83d&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1837f83d"]])

export default __exports__